import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import AcademicPlanService from "../../Services/AcademicPlan.service";
import PlanStatusWidget from "../Presentational/Widgets/PlanStatusWidget";
import useService from "../Hooks/useService";
const PlanStatusContainer = () => {
    const [activityState, loadActivity] = useService(AcademicPlanService.getActivity);
    React.useEffect(() => {
        loadActivity();
    }, [loadActivity]);
    return (_jsx(PlanStatusWidget, { planStatusState: activityState, refresh: loadActivity }));
};
export default PlanStatusContainer;
